import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useDraggable } from '@dnd-kit/core';
import { Box, Typography } from '@mui/material';
import { DragIndicator } from '@mui/icons-material';
import React from 'react';

export default function RequirementPassengerRow({ params }: { params: GridRenderCellParams }) {
    const dragData = {
        id: params.row.id,
        data: {
            stop: params.row.stop,
            passengerWorkerId: params.row.id,
            passengerName: params.row.name,
        },
    };

    const { attributes, listeners, setNodeRef } = useDraggable(dragData);

    if (params.row.type !== 'STOP') {
        return (
            <>
                <Box ref={setNodeRef} {...attributes} id={params.row.id} sx={{ display: 'flex', alignItems: 'center' }}>
                    <DragIndicator
                        {...listeners}
                        sx={{
                            verticalAlign: 'middle',
                            cursor: 'grab',
                        }}
                    />
                    <Typography
                        sx={{
                            backgroundColor: params.row.IsYellowBackgroundColor ? 'yellow' : '',
                        }}
                        title={params.row.name}
                    >
                        {params.row.name}
                    </Typography>
                </Box>
            </>
        );
    }

    return (
        <Typography
            m={0}
            p={0}
            paragraph
            sx={{
                display: 'inline-block',
                verticalAlign: 'middle',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflowX: 'hidden',
                maxWidth: '95%',
                backgroundColor: params.row.IsYellowBackgroundColor ? 'yellow' : '',
            }}
            title={params.row.stop.Name}>
            {params.row.stop.Name}
        </Typography>
    );
}